export enum SubscriptionEnvironmentEnum {
  PRODUCTION = 'PRODUCTION',
  SANDBOX = 'SANDBOX',
}
